import { MonitorCheck } from "lucide-react";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { base_url } from "../../config";

const ExhibitorAccessInstructions = () => {
  return (
    <div className="p-4 text-sm  rounded-lg">
      <h2 className="font-semibold mb-2">How to Grant Exhibitor Registration Access</h2>
      <p className="mb-2">
        Enter email addresses or domains to grant exhibitor registration access:
      </p>
      <ul className="list-disc list-inside mb-2">
        <li>
          To allow access to all users from a domain, enter: <code className="bg-gray-200 p-1 rounded">@example.com</code>
        </li>
        <li>
          To allow access to a specific user, enter: <code className="bg-gray-200 p-1 rounded">user@example.com</code>
        </li>
      </ul>
    </div>
  );
};

export default function App() {
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  const [saveMessage, setSaveMessage] = useState("");

  useEffect(() => {
    axios
      .get(`${base_url}/api/admin/exhibitors`)
      .then((response) => {
        setText(response.data.text);
      })
      .catch((error) => {
        console.error("Error fetching exhibitors :", error);
      });
  }, []);

  const handleSave = async () => {
    setSaving(true);
    setSaveMessage("");
    try {
      await axios.post(`${base_url}/api/admin/exhibitors`, { text });
      setSaveMessage("Sponsors list updated successfully!");
    } catch (error) {
      setSaveMessage("Error updating sponsors list.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div className="text-2xl mt-4 pb-4 font-bold flex gap-8 items-center">
        <MonitorCheck />
        Exhibitors
      </div>
        <ExhibitorAccessInstructions />
      <div className="flex items-center gap-6 mb-4">
        <textarea
          className="border rounded p-2 w-full min-h-[100px] text-sm"
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={15}
        />
       
      </div>
      <div className="flex justify-end">
       <div className="flex items-center gap-4">
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? "Saving..." : "Update Sponsor Domains"}
          </button>
          {saveMessage && (
            <span className="text-sm text-gray-600">{saveMessage}</span>
          )}
        </div>
        </div>
    </>
  );
}
